import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { stcPageQueryOptions } from "~/app/api/pageData/stcPageQuery";
import type { StcPageInitialData } from "~/app/api/pageData/stcPageInitialData";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { createSTCfinderPage } from "~/pages/StcFinderPage/StcFinderPage";

function StcRoute() {
  const result = useLoaderData({
    from: "/stc",
  }) as PageInitialData<StcPageInitialData>;
  const shellProps = useStorefrontShellProps();
  const stcPageData = result.data?.stcPageData;

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      {stcPageData ? createSTCfinderPage(stcPageData) : null}
    </StorefrontShellFrame>
  );
}

export async function loadStcPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(stcPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const stcRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/stc",
  loader: async ({ context }) => loadStcPageData(context),
  component: StcRoute,
});
